module.exports = __webpack_public_path__ + "assets/public/imgs/logos/mysql-database.svg";